import $axios from '../services/api.js'

const state = () => ({
    quranSurahBookmark: [],
    khazanahBookmark: [],
    bookmark: []
})

const mutations = {
    ASSIGN_DATA_QURAN_SURAH_BOOKMARK(state, payload) {
        state.quranSurahBookmark = payload
    },
    ASSIGN_DATA_KHAZANAH_BOOKMARK(state, payload) {
        state.khazanahBookmark = payload
    },
    ASSIGN_DATA_BOOKMARK(state, payload) {
        state.bookmark = state.bookmark.concat(payload)
    }
}

const actions = {
    saveBookmarkPage({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.post(`api/bookmark-page`, payload)
                .then((response) => {
                    commit('ASSIGN_DATA_BOOKMARK', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getQuranSurahBookmark({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`api/bookmark/quran`)
                .then((response) => {
                    commit('ASSIGN_DATA_QURAN_SURAH_BOOKMARK', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getKhazanahBookmark({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`api/bookmark/khazanah`)
                .then((response) => {
                    commit('ASSIGN_DATA_KHAZANAH_BOOKMARK', response.data.data)
                    resolve(response.data)
                })
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}